import { DocumentData } from "types";
import { SpecialUploadType } from "./types";

export const encodeObjectPath = (path: string) =>
  path.split("/").map(encodeURIComponent).join("/");
export const supportingFilename = (doc: Pick<DocumentData, "name">) =>
  doc.name.split("/").pop() || "document";
export const sanitizeSupportingFilename = (name: string) => {
  const safe = name.replace(/[\\/\u0000-\u001f\u007f]/g, "").trim();
  if (!safe || /^[. ]+$/.test(safe))
    throw new Error("supportingDocuments.invalidFile");
  return safe;
};
export const supportingDocuments = (documents: DocumentData[] = []) => {
  const seen = new Set<string>();
  return documents.filter((doc) => {
    if (doc.type !== SpecialUploadType.supportingDocument) return false;
    const identity = doc.key || doc.name;
    if (seen.has(identity)) return false;
    seen.add(identity);
    return true;
  });
};
export const copyableDocuments = (documents: DocumentData[] = []) =>
  documents.filter(
    (doc) =>
      doc.type === SpecialUploadType.supportingDocument ||
      doc.name.startsWith("/upload/") ||
      doc.location?.includes("/upload/"),
  );
